import React, { useEffect, useState } from 'react';
import LiveContext from '../../../contexts/LiveContext';
import PreferitiMenuCompetitionItem from './MenuCompetitionItemLive';
import { getConfiguration } from '../../../data/utils';

function MenuCountryItem(props) {
    const liveContext = React.useContext(LiveContext);
    const [isCollapsed, setIsCollapsed] = useState(initCollapsed());
    const conf = getConfiguration();

    function initCollapsed() {
        return !((props.menuLiveTogglers&&props.menuLiveTogglers.selectedCountries.includes(props.id)) || (liveContext.currentMatch&&liveContext.currentMatch.categoryRef===props.id));
    }
    
    function handleClick(idCountry,e) {
        props.menuLiveTogglers.toggleCountry(idCountry)
        setIsCollapsed(!isCollapsed);
        e.stopPropagation();
    }

    useEffect(function() {
        setIsCollapsed(initCollapsed());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [liveContext.currentMatch]);

    const competitionsList = props.tournaments.map(function(competition) {
        return <PreferitiMenuCompetitionItem key={competition.id} {...competition} sportId={props.sportId} countryId={props.id} />
    });

    const icoCategory = props.categoryIcon;
    return (
        <div className="regione-widget">
            <div className={"elemento-competizioni-widget pointer toggle-nascondi-live tog-menu "+(isCollapsed?"collapsed":"")} data-toggle="collapse" data-target={"#menu-country-" + props.id} onClick={handleClick.bind(this, props.id)}>
                <div className="paese-widget-sx">
                    <div className={`img-fluid img-flags ico-cat ${icoCategory}`}></div>
                    {props.descrizione}
                </div>
                <span> { conf.iwh ? `(${props.tournamentsCount})` : props.tournamentsCount}</span>
            </div>
            <div className={"competizione-sub collapse "+(!isCollapsed?"show":"")} id={"menu-country-" + props.id}>
                {competitionsList}
            </div>
        </div>
    );
}
    
export default MenuCountryItem;